import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  consultaCantinaCreditoSolicitacaoTransacaoPix,
  findCantinaCreditoSolicitacaoByCurrentInstituicao,
} from "./api-cantina-credito-solicitacao";
import { errorMessage, infoMessage } from "../../../util/ConfirmAlertUtil";
import { infoToast, success } from "../../../util/ToastUtil";
import Container from "../../UI/Container";
import { EMPTY_PAGE } from "../CantinaPageShared";
import CantinaCreditoSolicitacaoPage from "./CantinaCreditoSolicitacaoPage";

const CantinaCreditoSolicitacaoContainer = () => {
  const [page, setPage] = useState(EMPTY_PAGE);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [verificandoCodigo, setVerificandoCodigo] = useState(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    findCantinaCreditoSolicitacaoByCurrentInstituicao(pageNumber)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else {
          setPage(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [pageNumber]);

  const handleVerificarPagamento = (codigo) => {
    setVerificandoCodigo(codigo);
    consultaCantinaCreditoSolicitacaoTransacaoPix(codigo)
      .then((data) => {
        if (!data || data.error) {
          // O servidor pode devolver uma mensagem ou uma lista de mensagens.
          const lista = [].concat(data?.message ?? []).filter(Boolean).map(String);
          const mensagem =
            lista.join("\n") || "Não foi possível verificar o pagamento. Tente novamente mais tarde.";
          // Pix expirado não é erro do sistema: o servidor cancela a transação após o prazo.
          if (lista.some((m) => m.includes("Estado Cancelada"))) {
            infoMessage(mensagem);
          } else {
            errorMessage(mensagem);
          }
          return;
        }
        setPage((prevState) => ({
          ...prevState,
          content: prevState.content.map((s) => (s.codigo === codigo ? data : s)),
        }));
        if (data.pixTransacao?.quitado) {
          success("Pagamento confirmado.");
        } else {
          infoToast("Pagamento ainda não identificado.");
        }
      })
      .finally(() => setVerificandoCodigo(null));
  };

  return (
    <Container>
      <Box mb={3}>
        <Typography variant="h6">Solicitações de Crédito da Cantina</Typography>
        <Typography variant="body2" color="text.secondary">
          Créditos solicitados por Pix ou cartão de crédito.
        </Typography>
      </Box>
      <CantinaCreditoSolicitacaoPage
        cantinaCreditoSolicitacaoPage={page}
        handleChangePage={(event, newPage) => setPageNumber(newPage)}
        handleVerificarPagamento={handleVerificarPagamento}
        verificandoCodigo={verificandoCodigo}
        isLoading={isLoading}
      />
    </Container>
  );
};

export default CantinaCreditoSolicitacaoContainer;
